(function($) {
    'use strict';
    $(function() {
    /********
     * ANIME.JS
     * Documentation found at: http://animejs.com/documentation/
     * Example:
        var pageLogo = new anime({
            targets: '.page-logo',
            translateX: 350,
            scale: 0.5,
            direction: 'alternate',
            loop: true,
        });
    ********/
        
        // Code...
        


    /********
     * ANIMATE.CSS
     * Documentation found at: https://github.com/daneden/animate.css
     * Add the class [animated] to the element you want to animate. You may also want to include the class [infinite] for an infinite loop.
     * Example with the [pulse] animation:
     $('.page-logo').addClass('animated infinite pulse');
    ********/
        
        // Code...
    });
})(jQuery);
  